var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-1.88486735 8.11852349h14.73632815l-3.67309573-5.20703803h1.02050783l3.9162597 5.20703803.364502.55870226-.364502.4968533-3.9162597 5.27893745h-1.02050783l3.67309573-5.27893745h-14.73632815z","fillRule":"evenodd","transform":"translate(2.384867 -1.146302)"}));
}

ArrowIcon.defaultProps = {"height":"14","viewBox":"0 0 17 14","width":"17"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
